import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Industry from './icon-industry.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Industry {...validProps} />;
}
SvgComponent.iconName = 'industry';

export const IndustryIcon = svgIconWrapper(SvgComponent);
